<ion-list-header lines="full">
  <h6 style="width: 100%">
    <ion-note color="danger" *ngIf="required">*</ion-note>
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      "
    >
      <ion-text style="white-space: pre-wrap">{{
        qNo + ". " + questionTitle
      }}</ion-text>
      <!-- <app-attachement-extension
        (attachementArray)="handleAttachementArray($event)"
      ></app-attachement-extension> -->
    </div>
  </h6>

  <ion-item
    *ngIf="note"
    lines="none"
    class="ion-no-margin ion-no-padding note-item"
  >
    <ion-label
      ><span style="font-weight: 600"
        >{{ "PAGESPECIFIC_TEXT.FORM_LIST.NOTE" | translate }}: </span
      ><span [innerText]="note"></span
    ></ion-label>
  </ion-item>

  <ng-container *ngIf="attachments && attachments.length > 0">
    <ng-container *ngFor="let attachment of imageTypeAttachments">
      <ion-img class="question-content-img" [src]="attachment"></ion-img>
    </ng-container>

    <ng-container *ngFor="let attachment of attachments">
      <ion-item
        *ngIf="!UtilService.IsFileImageType(attachment.fileExtension)"
        lines="none"
        class="form-item"
        (click)="openFile(attachment)"
      >
        <ion-img *ngIf="attachmentIcon" [src]="attachmentIcon"></ion-img>
        <ion-icon
          slot="start"
          *ngIf="!attachmentIcon"
          [src]="UtilService.FileIcon(attachment.fileExtension)"
        ></ion-icon>
        <ion-label>
          {{ attachment.documentTitle }}
        </ion-label>
      </ion-item>
    </ng-container>
  </ng-container>
</ion-list-header>
